/**
 * app/(marketing)/legal/terms.tsx - getabeam.com Terms of Service (web, public).
 * Content lives in src/marketing/legal.ts; rendering in src/marketing/legalPage.tsx.
 */
import { LegalPage } from '../../../src/marketing/legalPage';
import { legalDocBySlug } from '../../../src/marketing/legal';

export default function TermsScreen() {
  return <LegalPage doc={legalDocBySlug('terms')} />;
}
